import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
const SectionOrganizationFeature = (props) => {
    const { isBlur, organizationFeatures } = props;
    return (_jsx("div", Object.assign({ className: 'about-consultant-organization-feature' }, { children: _jsx("ul", Object.assign({ className: 'oranienbaum_ul_list' }, { children: organizationFeatures.map(({ id, value }) => (_jsx(BlurText, Object.assign({ component: 'li', isBlur: isBlur }, { children: value }), id))) })) })));
};
SectionOrganizationFeature.propTypes = {
    isBlur: propBool().isRequired,
    organizationFeatures: propArrayShape().isRequired,
};
export default SectionOrganizationFeature;
